import { useNavigate } from "@tanstack/react-router";
import { Button } from "../../@/components/ui/button";


export default function ComingSoon({ title, description }) {
    const navigate = useNavigate();

    const handleBack = () => {
        if (typeof window !== "undefined" && window.history?.length > 1) {
            window.history.back();
            return;
        }

        navigate({ to: "/" });
    };

    return (
        <div className="flex flex-col w-full min-h-screen">
            <h1>{title || "Coming Soon"}</h1>
            <p className="text-(--neutral-700)">
                {description || "We’re working on this page and will share it soon."}
            </p>

            <div className="flex flex-col items-center justify-center min-h-[50vh] bg-(--neutral-50) mt-6">
                <img
                    src="/undraw_under-construction_c2y1.svg"
                    alt="Page coming soon"
                    style={{ width: "50%", maxWidth: "400px" }}
                />
                <h2 className="mt-8 text-center text-(--neutral-900)">
                    This page is coming soon
                </h2>
                <p className="mt-2 text-center text-(--neutral-700) max-w-180 px-4">
                    This page is currently under development, however, you can help us make it better.{' '}
                    <a
                        href="https://teable.zinduaschool.com/share/shr02vkM9ypwxebB85H/view"
                        target="_blank"
                        rel="noreferrer"
                        className="underline underline-offset-4 text-(--color-primary) hover:text-(--color-accent)"
                    >
                        Submit a feature suggestion
                    </a>
                    .
                </p>
                <Button
                    variant=""
                    className="w-1/4 mt-6 capitalize"
                    onClick={handleBack}
                >
                    Go Back
                </Button>
            </div>
        </div>
    );
}
